'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = VeganSvg;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function VeganSvg(props) {
    var width = props.width,
        height = props.height,
        primaryColor = props.primaryColor,
        _props$i18n = props.i18n,
        i18n = _props$i18n === undefined ? { get: function get() {
            return null;
        } } : _props$i18n;


    return _react2.default.createElement(
        'svg',
        { role: 'img', 'aria-labelledby': 'fullimgVegan', width: width, height: height, viewBox: '0 0 13 27', xmlns: 'http://www.w3.org/2000/svg', 'data-hook': 'wixrest-menus-icon-full-vegan' },
        _react2.default.createElement(
            'title',
            { id: 'fullimgVegan' },
            ' ',
            i18n.get('openrest_menubuilderv3_dishlabels_vegan') || 'vegan'
        ),
        _react2.default.createElement('path', {
            d: 'M12.5050505 7.434c-.3070707-.271-.6868687-.415-1.1010101-.415-.3181818 0-.610101.092-.8676768.271-.2363636.163-.4292929.39-.56969693.671l-.01313132.029-.0111111.028-3.35353536 8.316-3.56363637-8.331C2.63838383 7.129 1.95252525 7 1.57777778 7c-.3949495 0-.75353536.138-1.06565657.409C.1777778 7.697 0 8.089 0 8.543c0 .257.04141414.471.12727273.653l4.8989899 11.482.010101.024.01111112.022c.13636363.268.33535353.491.57676767.648.23434344.153.5030303.244.7929293.265l.03535353.003.03535354-.001c.27979797-.004.56666665-.09.82727272-.249.27676767-.169.48888888-.409.63434343-.717L12.8555556 9.194C12.9525253 8.954 13 8.733 13 8.525c0-.426-.1717172-.803-.4949495-1.091',
            fill: primaryColor })
    );
}

VeganSvg.displayName = 'VeganSvg';
VeganSvg.propTypes = {
    width: _propTypes2.default.number,
    height: _propTypes2.default.number,
    primaryColor: _propTypes2.default.string
};
VeganSvg.defaultProps = {
    width: 13,
    height: 27,
    primaryColor: '#7ec77b'
};